import { render, staticRenderFns } from "./ColorModule.vue?vue&type=template&id=0c5dacfe&scoped=true"
import script from "./ColorModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModule.vue?vue&type=style&index=0&id=0c5dacfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5dacfe",
  null
  
)

export default component.exports